export class CmsListFlexType {
  static readonly CCN = 'cms_list_ccn'
  static readonly CERT = 'cms_list_cert'
  static readonly CONTENT = 'cms_list_content'
  static readonly JOB = 'cms_list_job'
  static readonly VIDEO = 'cms_list_video'
  static readonly DOCUMENT = 'cms_list_document'
}
